import React from 'react';
import { localise } from '../../../services/lang/lang';
import ModalWithSidebar from '../Modal/ModalWithSidebar';
import { useUnsavedChanges } from '../UnsavedChanges/UnsavedChangesProvider';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import RenderIfElse from '../RenderIf/RenderIfElse';
import OfficerAssessmentModalShareTabPanels from './Share/OfficerAssessmentModalShareTabPanels';
import OfficerAssessmentModalTabPanels from './OfficerAssessmentModalTabPanels';
const OfficerAssessmentModal = ({ officerAssessment, onClose, canEdit, }) => {
    const { attemptNavigate } = useUnsavedChanges();
    const { isShare } = useInspectionDetailContext();
    return (React.createElement(ModalWithSidebar, { tabTitles: [localise('DETAILS'), localise('NOTES')], onClose: onClose, title: localise('OFFICER_ASSESSMENT'), isOpen: true, isFullWidth: true, verifyOnBlur: attemptNavigate, selectedTab: 0 },
        React.createElement(SuspenseWrapper, null,
            React.createElement(RenderIfElse, { condition: isShare, then: React.createElement(OfficerAssessmentModalShareTabPanels, { officerAssessment: officerAssessment }), else: React.createElement(OfficerAssessmentModalTabPanels, { canEdit: canEdit, officerAssessmentId: officerAssessment.id }) }))));
};
export default OfficerAssessmentModal;
